define("shared/utils/formatters/format-profile-nickname-for-linkinbio-page-slug", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  const formatProfileNicknameForLinkinbioPageSlug = socialProfile => {
    const nickname = socialProfile?.get('nickname');
    return nickname?.replace(/\./g, '-') ?? '';
  };

  var _default = formatProfileNicknameForLinkinbioPageSlug;
  _exports.default = _default;
});